import { forwardRef, useImperativeHandle } from 'react'

import { LoadingTurbo } from 'atoms'
import {
  Box,
  HStack,
  Heading,
  Text,
  Pressable,
  Button,
  VStack,
  Center,
  Spinner,
  useBreakpointValue
} from 'native-base'
import { CurrentViewTypesRef } from 'src/components/templates/ContactScreenTemplate/ContactScreenTemplate'

import { NotesDesktop } from './desktop'
import { useTabComponent } from './hook'
import { TabCommonProps } from './types'

export const NotesMobile = forwardRef<CurrentViewTypesRef, TabCommonProps>(
  ({ handleGoToNoteDetails, handleGoToNoteCreateDetails, contactId }, ref) => {
    const { allNotes, onScrollEndDragAllNotesList, allNotesIsFetchingNextPage, isLoading } =
      useTabComponent({
        contactId: contactId ?? ''
      })

    useImperativeHandle(ref, () => ({
      onScrollEndDragContent: onScrollEndDragAllNotesList
    }))

    return (
      <VStack mt={10} flex={1} safeAreaBottom>
        {isLoading ? (
          <Center h={360} w="full" position="absolute" zIndex={9}>
            <LoadingTurbo size={100} />
          </Center>
        ) : (
          <>
            <Heading fontSize="18px" color="gray.600" mb={6}>
              Caderninho
            </Heading>

            {allNotes.length > 0 &&
              allNotes.map((note) => (
                <Pressable mb={2} onPress={() => handleGoToNoteDetails?.(note.id)} key={note.id}>
                  <Box bg="white" borderRadius="20px" w="full" p={4}>
                    <Heading fontSize="14px" color="gray.700" mb={1}>
                      {note.title}
                    </Heading>
                    <Text fontSize="12px" color="gray.400" isTruncated mb={1}>
                      {note.detail}
                    </Text>
                    <HStack alignItems="center">
                      <Text fontSize="12px" color="gray.400" mb={1}>
                        {note.created_at}
                      </Text>
                      {note?.type && (
                        <>
                          <Box bg="gray.400" borderRadius="full" size={1} mx={1} />
                          <Text fontSize="12px" color="gray.400" mb={1} textTransform="capitalize">
                            {note.type}
                          </Text>
                        </>
                      )}
                    </HStack>
                  </Box>
                </Pressable>
              ))}

            {allNotes.length === 0 && (
              <Text flexGrow={1} textAlign="center" fontSize="16px" color="gray.500">
                Nenhuma nota ainda
              </Text>
            )}

            {allNotesIsFetchingNextPage ? (
              <Center flex={1} mx={2} mb={10}>
                <Spinner />
              </Center>
            ) : null}
            <Button mb={10} mt={6} colorScheme="gray" onPress={handleGoToNoteCreateDetails}>
              Nova Nota
            </Button>
          </>
        )}
      </VStack>
    )
  }
)

export const Notes = forwardRef<CurrentViewTypesRef, TabCommonProps>((props, ref) => {
  const isMobile = useBreakpointValue({ base: true, lg: false })

  if (!isMobile) return <NotesDesktop {...props} ref={ref} />

  return <NotesMobile {...props} ref={ref} />
})
